import { render, staticRenderFns } from "./page-background-category.vue?vue&type=template&id=842f8c20"
import script from "./page-background-category.vue?vue&type=script&lang=ts"
export * from "./page-background-category.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports